import React from "react";
import { Paper, Box, Typography, Button } from "@mui/material";
import { CallMerge as MergeIcon } from "@mui/icons-material";

export default function MergeActionBar({ selectedCount, onCancel, onMerge }) {
  return (
    <Paper
      elevation={3}
      sx={{
        position: "sticky",
        bottom: 0,
        mt: 1,
        px: 3,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderTop: "1px solid",
        borderColor: "primary.main",
        bgcolor: "secondary.main",
        color: "common.white",
        zIndex: 10,
        borderRadius: "6px 6px 0 0",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, color: "inherit" }}>
        {selectedCount} client{selectedCount !== 1 ? "s" : ""} selected
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          size="small"
          onClick={onCancel}
          variant="outlined"
          sx={{
            textTransform: "none",
            color: "common.white",
            borderColor: "rgba(255,255,255,0.4)",
            "&:hover": {
              borderColor: "primary.main",
              bgcolor: "rgba(197, 160, 111, 0.16)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          disabled={selectedCount !== 2}
          startIcon={<MergeIcon />}
          onClick={onMerge}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Merge Selected
        </Button>
      </Box>
    </Paper>
  );
}
